import { required, minLength } from 'vuelidate/lib/validators';
import { forcePasswordPolicy } from '@/app/utils/validations/validations';
import ConfirmCode from '@/app/modules/auth/components/confirm-code/confirm-code.vue';

export default {
  name: 'sign-in',
  components: {
    ConfirmCode,
  },
  data: () => ({
    loading: false,
    hasInvite: false,
    hasConfirmCode: false,
    confirmCode: '',
    show: true,
    form: {
      username: '',
      password: '',
    },
  }),

  computed: {
    hasAuthError() {
      return this.$store.getters['auth/hasError'];
    },
    authError() {
      return this.$store.getters['auth/getAuthError'];
    },
  },
  watch: {
    async hasAuthError(err) {
      if (err) {
        this.checkAuthError();
      }
    },
  },
  methods: {
    async checkAuthError() {
      if (this.authError.code === 'UserNotConfirmedException') {
        await this.$store.dispatch('auth/resendConfirmationCode', { username: this.form.username });
        this.hasConfirmCode = true;
        this.loading = false;
      }
    },
    formattedUsername() {
      let { username } = this.form;
      if (username.includes('@')) {
        username = this.form.username.toLowerCase();
      }
      return username;
    },
    handleNotYou() {
      this.$store.dispatch('auth/clearError');
      this.hasInvite = false;
      this.form.username = '';
    },
    async signIn() {
      this.loading = true;
      this.$v.form.$touch();
      if (!this.$v.form.$anyError) {
        await this.$store.dispatch('auth/login', { username: this.formattedUsername(), password: this.form.password });
        if (this.$store.getters['auth/loggedIn']) {
          this.$mixpanel.identify(this.$store.getters['auth/getCognitoID']);
          let userSource;
          if (this.$route.query.inviteID) {
            userSource = 'Invitee';
          }
          if (this.$route.query.shareID) {
            userSource = 'Sharee';
          }
          this.$mixpanel.people.set_once({
            $first_name: this.$store.getters['auth/getUserGivenName'],
            $last_name: this.$store.getters['auth/getUserFamilyName'],
            nickname: this.$store.getters['auth/getUserNickname'],
            username: this.$store.getters['auth/getUserNickname'],
            $email: this.$store.getters['auth/getUserEmail'],
            createdAt: new Date().toISOString(),
            firstSignIn: new Date().toISOString(),
            userSource,
          });
          this.$mixpanel.people.set({
            lastSignIn: new Date().toISOString(),
            usernameOrEmail: this.formattedUsername(),
            'utm_source (last touch)': this.$cookies.get('utm_source'),
            'utm_medium (last touch)': this.$cookies.get('utm_medium'),
            'utm_campaign (last touch)': this.$cookies.get('utm_campaign'),
          });
          this.$mixpanel.track('signIn', {
            usernameOrEmail: this.formattedUsername(),
          });

          if (this.$route.query && this.$route.query.client_id) {
            this.$router.replace({
              path: '/oauth2/authorize',
              query: this.$route.query,
            })
              .catch(err => console.log(err));
          } else if (this.$route.query && this.$route.query.inviteID) {
            this.$router.push(`/invite?action=accept&inviteID=${this.$route.query.inviteID}`).catch((err) => {
              this.$rollbar.info('Router', {
                location: 'sign-in',
                message: err.message,
              });
            });
          } else if (this.$route.query && this.$route.query.shareID) {
            this.$router.push({
              name: 'home',
              query: {
                shareID: this.$route.query.shareID,
              },
            });
          } else {
            this.$router.push('/').catch((err) => {
              this.$rollbar.info('Router', {
                location: 'sign-in',
                message: err.message,
              });
            });
          }
        } else if (this.$store.getters['auth/hasAction']) {
          if (this.$store.state.auth.action.challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.$router.push('/auth/new-password');
          } else if (this.$store.state.auth.action.challengeName === 'EMAIL_VERIFICATION_REQUIRED') {
            this.$router.push('/auth/confirm-email');
          }
          this.loading = false;
        } else {
          this.loading = false;
        }
      }
    },
    async handleClick(value) {
      if (value === 'cancel') {
        this.hasConfirmCode = false;
      } else if (value === 'submit') {
        try {
          await this.$store.dispatch('auth/confirmSignUp', {
            username: this.formattedUsername(),
            code: this.confirmCode.toString(),
          });
          this.hasConfirmCode = false;
        } catch (err) {
          console.log(err);
        }
      }
    },
  },
  mounted() {
    if (this.$route.query) {
      if (this.$route.query.email) {
        this.form.username = this.$route.query.email;
      }

      if (this.$route.query.inviteID) {
        this.hasInvite = true;
      }
    }
  },
  validations: {
    form: {
      username: {
        required,
        minLength: minLength(8),
      },
      password: {
        required,
        minLength: minLength(8),
        forcePasswordPolicy,
      },
    },
  },
};
